// This code was gifted by Anthony Messerschmidt from his personal collection of code.


/*
Must Have:
At least 8 characters in length
Contain at least 1 character of EACH of the following types:
  Lower case letters (a-z),
  Upper case letters (A-Z),
  Numbers (i.e. 0-9),
  Special characters (e.g. !@#$%^&* )
No parts of the username (but we don't know how to write an algorithm for this so we don't include it in this validation code)
*/

export class PasswordEvaluator {

  // TODO: Enhancement suggestion: it might be better to have these values in Sitefinity so they can be changed as needed.
  public static readonly MIN_LENGTH = 8;
  public static readonly NUM_OF_REQUIRED_CHAR_TYPES = 3;
  public static readonly MIN_USERNAME_SUBSTRING_LENGTH = 4;
  public static currentUsername = '';
  public static currentUsernameCheckSetting = false;
  public static isValid(password: string): boolean {
    if (password == null) {
      return false;
    }
    var usernamecheck = PasswordEvaluator.doesNotContainUsername(PasswordEvaluator.currentUsername, password, PasswordEvaluator.currentUsernameCheckSetting);
    var value = PasswordEvaluator.isLongEnough(password)
      && PasswordEvaluator.hasLowerCaseLetters(password)
      && PasswordEvaluator.hasUpperCaseLetters(password)
      && PasswordEvaluator.hasDigits(password)
      && PasswordEvaluator.hasSpecialCharacters(password)
      && usernamecheck;
      return value;
  }

  public static isLongEnough(password: string): boolean {
    if (password == null) {
      return false;
    }
    return password.length >= PasswordEvaluator.MIN_LENGTH;
  }

  public static hasLowerCaseLetters(password: string): boolean {
    if (password == null) {
      return false;
    }
    return PasswordEvaluator.LOWERCASE_RE.test(password);
  }

  public static containsRecommendedCharacterTypes(password: string): boolean {
    if (password == null) {
      return false;
    }
    const regexes = [
      PasswordEvaluator.UPPERCASE_RE,
      PasswordEvaluator.LOWERCASE_RE,
      PasswordEvaluator.NUMBER_RE,
      PasswordEvaluator.SPECIAL_CHAR_RE,
    ];
    return PasswordEvaluator.hasPassedManyRegExs(password, regexes, PasswordEvaluator.NUM_OF_REQUIRED_CHAR_TYPES);
  }

  public static hasUpperCaseLetters(password: string): boolean {
    if (password == null) {
      return false;
    }
    return PasswordEvaluator.UPPERCASE_RE.test(password);
  }

  public static hasDigits(password: string): boolean {
    if (password == null) {
      return false;
    }
    return PasswordEvaluator.NUMBER_RE.test(password);
  }

  public static hasSpecialCharacters(password: string): boolean {
    if (password == null) {
      return false;
    }
    return PasswordEvaluator.SPECIAL_CHAR_RE.test(password);
  }

  public static hasRepeatingCharacter(password: string, minNumInARow: number): boolean {
    const regEx = new RegExp(`(.)\\1{${minNumInARow - 1},}`); // no more than numInARow duplicate characters in a row

    return regEx.test(password);
  }


  /**
   * Validates that a password doesn't contain parts of the username
   * @param password - The password to validate
   * @param username - The username to check against (can be email or plain username)
   * @returns true if password is valid (doesn't contain username parts), false otherwise
   */
  public static doesPasswordHasUsername = true;
  public static doesNotContainUsername(username: string, password: string, checkUsernameInPassword: boolean): boolean {

    if(password == "")
      return false;

    PasswordEvaluator.currentUsernameCheckSetting =  checkUsernameInPassword;

    if(checkUsernameInPassword== false) {
      PasswordEvaluator.doesPasswordHasUsername = false;
      return true;
    }

    if(password.length < this.MIN_USERNAME_SUBSTRING_LENGTH) {
      PasswordEvaluator.doesPasswordHasUsername = false;
      return true;
    }

    // if username return true
   if (!username) {
      PasswordEvaluator.doesPasswordHasUsername = false;
      return true; // If no username provided, skip this validation
    }
    PasswordEvaluator.currentUsername =  username;

    if (password == null) {
      return false;
    }

    // Extract the local part if username is an email
    const localPart = username.includes('@')
      ? username.split('@')[0]
      : username;
    // Convert to lowercase for case-insensitive comparison
    const lowerPassword = password.toLowerCase();
    const lowerUsername = localPart.toLowerCase();

    // Split username by common delimiters to get meaningful parts
    const usernameParts = lowerUsername.split(/[._-]+/).filter(part => part.length >= PasswordEvaluator.MIN_USERNAME_SUBSTRING_LENGTH);

    // Check if any username part exists in the password
    for (const part of usernameParts) {
      if (lowerPassword.includes(part)) {
        PasswordEvaluator.doesPasswordHasUsername = true;
        return false;
      }
    }

    // Also check for consecutive substrings of the full username
    for (let i = 0; i <= lowerUsername.length - PasswordEvaluator.MIN_USERNAME_SUBSTRING_LENGTH; i++) {
      const substring = lowerUsername.substring(i, i + PasswordEvaluator.MIN_USERNAME_SUBSTRING_LENGTH);

      // Skip substrings that are just delimiters or very common patterns
      if (/^[._-]+$/.test(substring)) {
        continue;
      }

      if (lowerPassword.includes(substring)) {
        PasswordEvaluator.doesPasswordHasUsername = true;
        return false;
      }
    }
    PasswordEvaluator.doesPasswordHasUsername = false;
    return true;
  }

  // TODO: Enhancement suggestion: it might be better to have these Regex values in Sitefinity so they can be changed as needed.
  private static readonly UPPERCASE_RE = /([A-Z])/;
  private static readonly LOWERCASE_RE = /([a-z])/;
  private static readonly NUMBER_RE = /([\d])/;
  // eslint-disable-next-line no-useless-escape
  private static readonly SPECIAL_CHAR_RE = /(["!#$%&’()*+,-.\/\\:;<=>?@[\]^_`{|}~])/;

  private static hasPassedManyRegExs(password: string, regExs: RegExp[], numOfRegExsToPass: number): boolean {
    if (password == null) {
      return false;
    }

    let count = 0;
    for (const regEx of regExs) {
      if (regEx.test(password)) {
        count++;

        if (count >= numOfRegExsToPass) {
          return true;
        }
      }
    }

    return false;
  }

  private constructor() {
    throw new Error('Instances of PasswordEvaluator are not allowed');
  }
}
